import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Card, Col, Divider, Form, message, Modal, Row, Select, Typography } from 'antd';
import { queryInvoiceInvalid } from '@api/incubator/invoice';
import { getIncuBaseList } from '@store/modules/incubator/incubator_list';
import { getAdjustData } from '@store/modules/finance/budget/adjust_data';
import { getIncuBaseInfo } from '@store/modules/incubator/incubator_base';
import { queryBatchImportBudgetGroupSet, queryBudgetGroupList } from '@api/finance/budget';
import ModalImport from '../finance/budget/ModalImport';
import ModalInvalid from './ModalInvalid';

const { Title } = Typography;
const FormItem = Form.Item;
class PageAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalImportVisible: false,
      modalAdjustVisible: false,
      modalInvalidVisible: false,
      modalIncubatorVisible: false,
      company: [],
      year: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.loadBudgetData();
    this.props.dispatch(getIncuBaseList());
    const d = new Date();
    const nowYear = d.getFullYear();
    this.setState({
      year: [nowYear, nowYear + 1],
    });
  }

  // 关闭弹窗
  hideModal = () => {
    this.setState({
      modalAdjustVisible: false,
      modalImportVisible: false,
      modalInvalidVisible: false,
      modalIncubatorVisible: false,
    });
  };

  /* -----------------------------------------------------------财务流程-------------------------------------------------------*/
  // 递归删除空的children
  formatGroup = arr => {
    arr.map((item, index) => {
      if (item.children) {
        if (item.children.length === 0) {
          delete item.children;
          return item;
        }
        if (item.children.length > 0) {
          this.formatGroup(item.children);
        }
      }
      return item;
    });
    return arr;
  };

  // 设置预算组
  formatOption = arr => {
    const { company } = this.state;
    (arr || []).map(item => {
      if (item.children && item.children.length > 0) {
        this.formatOption(item.children);
      }
      company.push(item);
      return item;
    });
    this.setState({ company });
  };

  // 加载预算组数据
  loadBudgetData = () => {
    queryBudgetGroupList({ isEnable: 1 }).then(res => {
      if (res.statusCode === 200) {
        this.formatGroup(res.data);
        this.formatOption(res.data);
      } else {
        message.error(res.message);
      }
    });
  };

  // 预算导入
  showModalImport = () => {
    this.setState({ modalImportVisible: true });
  };

  handleImport = params => {
    this.hideModal();
    queryBatchImportBudgetGroupSet(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.push(`/finance/budget/set_manage_mine`);
      } else {
        message.error(res.message);
      }
    });
  };

  // 预算调整
  showModalAdjust = () => {
    this.setState({ modalAdjustVisible: true });
  };

  handleAdjust = () => {
    const { validateFields } = this.props.form;
    validateFields(['groupUuid', 'year'], (err, values) => {
      if (!err) {
        this.hideModal();
        this.setAdjustGroup(values.groupUuid);
        this.props.router.push(`/finance/budget/initiate/${values.year}/adjust`);
      }
    });
  };

  // 预算调整数据生成
  setAdjustGroup = id => {
    const { company } = this.state;
    company.map(item => {
      if (item.uuid === id) {
        this.props.dispatch(getAdjustData(item));
      }
      return item;
    });
  };
  /* ------------------------------------------------财务流程结束--------------------------------------------------------------*/

  /* ----------------------------------------------孵化器流程-------------------------------------------------------------------*/
  showModalIncubator = type => {
    this.setState({
      incubatorType: type,
      modalIncubatorVisible: true,
    });
  };

  handleIncubator = () => {
    const { validateFields } = this.props.form;
    const { incubatorType } = this.state;
    if (incubatorType === 'enter') {
      validateFields(['incubatorUuid', 'enterType'], (err, values) => {
        if (!err) {
          this.hideModal();
          values.enterType === 'station' &&
            this.props.router.push(`/incubator/one/${values.incubatorUuid}/contract/station`);
          values.enterType === 'address' &&
            this.props.router.push(`/incubator/one/${values.incubatorUuid}/contract/address`);
        }
      });
    } else {
      validateFields(['incubatorUuid'], async (err, values) => {
        if (!err) {
          this.hideModal();
          await this.props.dispatch(getIncuBaseInfo({ uuid: values.incubatorUuid }));
          switch (incubatorType) {
            case 'back':
              this.props.router.push(`/incubator/one/${values.incubatorUuid}/back`);
              break;
            case 'invoice':
              this.props.router.push(`/incubator/one/${values.incubatorUuid}/invoice/add`);
              break;
            case 'refund':
              this.props.router.push(`/incubator/one/${values.incubatorUuid}/refund`);
              break;
            default:
              break;
          }
        }
      });
    }
  };

  showModalInvalid = () => {
    this.setState({
      modalInvalidVisible: true,
    });
  };

  handleInvalid = params => {
    queryInvoiceInvalid(params).then(res => {
      if (res.statusCode === 200) {
        this.hideModal();
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };
  /* --------------------------------------------孵化器流程结束------------------------------------------------------------------*/

  render() {
    const {
      modalIncubatorVisible,
      modalInvalidVisible,
      modalImportVisible,
      modalAdjustVisible,
      incubatorType,
      company,
      year,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    return (
      <Card>
        <Row>
          <Col span={4}>
            <Title level={4}>财务流程</Title>
          </Col>
          <Col span={20}>
            <Col span={4}>
              <Link to="/finance/e_manage/add" style={{ fontSize: '20px' }}>
                报销申请
              </Link>
            </Col>
            <Col span={4}>
              <Link to="/finance/p_manage/add" style={{ fontSize: '20px' }}>
                付款申请
              </Link>
            </Col>
            <Col span={4}>
              <Link to="/finance/l_manage/add" style={{ fontSize: '20px' }}>
                借款申请
              </Link>
            </Col>
            <Col span={4}>
              <Link to="/finance/i_manage/add" style={{ fontSize: '20px' }}>
                开票申请
              </Link>
            </Col>
            <Col span={4}>
              <Link onClick={this.showModalImport} style={{ fontSize: '20px' }}>
                预算导入
              </Link>
            </Col>
            <Col span={4}>
              <Link onClick={this.showModalAdjust} style={{ fontSize: '20px' }}>
                预算调整
              </Link>
            </Col>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={4}>
            <Title level={4}>行政流程</Title>
          </Col>
          <Col span={20}>
            <Col span={4}>
              <Link to="/administrative/s_manage/add" style={{ fontSize: '20px' }}>
                用章申请
              </Link>
            </Col>
            <Col span={4}>
              <Link to="/administrative/material/borrow_manage/add" style={{ fontSize: '20px' }}>
                资料借用
              </Link>
            </Col>
            <Col span={4}>
              <Link to="/administrative/purchase_manage/add" style={{ fontSize: '20px' }}>
                采购申请
              </Link>
            </Col>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={4}>
            <Title level={4}>人事流程</Title>
          </Col>
          <Col span={20}>
            <Row>
              <Col span={4}>
                <Link to="/hr/w_manage/add" style={{ fontSize: '20px' }}>
                  工资申请
                </Link>
              </Col>
              <Col span={4}>
                <Link to="/hr/b_manage/add" style={{ fontSize: '20px' }}>
                  年终奖申请
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={4}>
            <Title level={4}>孵化器流程</Title>
          </Col>
          <Col span={20}>
            <Col span={4}>
              <Link onClick={() => this.showModalIncubator('enter')} style={{ fontSize: '20px' }}>
                入驻申请
              </Link>
            </Col>
            <Col span={4}>
              <Link onClick={() => this.showModalIncubator('back')} style={{ fontSize: '20px' }}>
                退款申请
              </Link>
            </Col>
            <Col span={4}>
              <Link onClick={() => this.showModalIncubator('invoice')} style={{ fontSize: '20px' }}>
                开票申请
              </Link>
            </Col>
            <Col span={4}>
              <Link to="/incubator/base/add" style={{ fontSize: '20px' }}>
                注册申请
              </Link>
            </Col>
            <Col span={4}>
              <Link onClick={() => this.showModalIncubator('refund')} style={{ fontSize: '20px' }}>
                错款退还
              </Link>
            </Col>
            <Col span={4}>
              <Link onClick={this.showModalInvalid} style={{ fontSize: '20px' }}>
                作废发票
              </Link>
            </Col>
          </Col>
        </Row>
        {modalImportVisible ? (
          <ModalImport cancel={this.hideModal} handleSubmit={this.handleImport} />
        ) : null}

        <Modal
          title="预算调整条件"
          visible={modalAdjustVisible}
          onOk={this.handleAdjust}
          onCancel={this.hideModal}
        >
          <Form>
            <FormItem label="选择预算组" {...formItemLayout}>
              {getFieldDecorator('groupUuid', {
                rules: [{ required: true, message: '请选择预算组' }],
              })(
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="请选择预算组"
                >
                  {company.map((item, index) => {
                    return <Select.Option key={item.uuid}>{item.name}</Select.Option>;
                  })}
                </Select>,
              )}
            </FormItem>
            <FormItem label="选择年份" {...formItemLayout}>
              {getFieldDecorator('year', {
                rules: [{ required: true, message: '请选择年份' }],
              })(
                <Select placeholder="请选择年份">
                  {year.map((item, index) => {
                    return <Select.Option key={item}>{item}</Select.Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Form>
        </Modal>
        <Modal
          title="申请条件"
          visible={modalIncubatorVisible}
          onOk={this.handleIncubator}
          onCancel={this.hideModal}
        >
          <Form>
            <FormItem label="选择孵化器" {...formItemLayout}>
              {getFieldDecorator('incubatorUuid', {
                rules: [{ required: true, message: '请选择预算组' }],
              })(
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="请选择孵化器"
                >
                  {this.props.incubatorData.map((item, index) => {
                    return <Select.Option key={item.uuid}>{item.name}</Select.Option>;
                  })}
                </Select>,
              )}
            </FormItem>
            {incubatorType === 'enter' ? (
              <FormItem label="选择类型" {...formItemLayout}>
                {getFieldDecorator('enterType', {
                  rules: [{ required: true, message: '请选择类型' }],
                })(
                  <Select placeholder="请选择类型">
                    <Select.Option key="address">添加地址合同</Select.Option>
                    <Select.Option key="station">添加基础孵化合同</Select.Option>
                  </Select>,
                )}
              </FormItem>
            ) : null}
          </Form>
        </Modal>
        {modalInvalidVisible ? (
          <ModalInvalid
            {...this.props}
            onCancel={this.hideModal}
            invalidInvoice={this.handleInvalid}
          />
        ) : null}
      </Card>
    );
  }
}

export default connect(state => ({ incubatorData: state.incubator_list }))(Form.create()(PageAdd));



// WEBPACK FOOTER //
// ./src/components/flow/PageAdd.js